import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/Reveal";
import { FALLBACK_SERVICES } from "@/lib/constants";
import api from "@/lib/api";
import { useEffect, useState } from "react";

export default function ServicesPreview() {
  const [services, setServices] = useState(FALLBACK_SERVICES);
  useEffect(() => {
    api.get("/services").then(({ data }) => data?.length && setServices(data)).catch(() => {});
  }, []);

  return (
    <section className="bg-ink-950 py-14 sm:py-28" data-testid="services-preview-section">
      <div className="container-brox">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <SectionHeading
            eyebrow="SERVICII"
            title={<>Tot ce are nevoie<br />proiectul tău.</>}
          />
          <Reveal delay={0.15}>
            <Link to="/servicii" className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-copper" data-testid="services-preview-all-link">
              Vezi toate serviciile
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>

        <div className="mt-9 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((svc, i) => (
            <Reveal key={svc.slug} delay={0.05 * (i % 3)} className="h-full">
              <Link
                to={`/servicii/${svc.slug}`}
                className="card-brox group flex h-full flex-col hover:border-copper/50"
                data-testid={`service-card-${svc.slug}`}
              >
                <div className="relative h-36 overflow-hidden sm:h-48">
                  <img
                    src={svc.hero_image}
                    alt={`${svc.title} — Brox Construct`}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-800 via-transparent to-transparent" aria-hidden="true" />
                  <span className="absolute left-4 top-4 font-mono text-xs text-copper">0{i + 1}</span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="display-title text-2xl text-paper">{svc.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{svc.tagline}</p>
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {svc.items.slice(0, 4).map((item) => (
                      <span key={item} className="border border-white/10 bg-ink-900 px-2 py-1 font-mono text-[10px] uppercase tracking-wider text-paper/60">
                        {item}
                      </span>
                    ))}
                    {svc.items.length > 4 && (
                      <span className="border border-copper/30 bg-copper/10 px-2 py-1 font-mono text-[10px] uppercase tracking-wider text-copper">
                        +{svc.items.length - 4}
                      </span>
                    )}
                  </div>
                  <span className="mt-auto inline-flex items-center gap-2 pt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-copper">
                    Detalii
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
